import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {AuthGuard} from '@patientlynk3/services/auth/auth.guard';
import {AuthService} from '@patientlynk3/services/auth/auth.service';
import {TokenInterceptor} from '@patientlynk3/services/token.interceptor';
import {DatabaseInterceptor} from '@patientlynk3/services/database.interceptor';
import { PLVariantInterceptor } from '@patientlynk3/services/pl-variant.interceptor';

@NgModule({
  providers: [
    AuthGuard,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: DatabaseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PLVariantInterceptor, multi: true },
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
  ]
})
export class AuthModule { }
